<template>
  <div class="school">
    <header class="school-title">今日被使用热门科目Top5</header>
    <div
      class="school-progress"
      v-for="(item, index) in subjectList"
      :key="index"
    >
      <p class="mb">
        <span class="fz" :class="{'school-color': item.id < 4}">{{ index+1 }}</span>
        <span class="lc">{{ item.name }}</span>
      </p>
      <el-progress :show-text="false" :percentage="item.num"></el-progress>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HotSubjectTop',
  data() {
    return {
      subjectList: [
        { id: 2, name: '数学', num: 80 },
        { id: 3, name: '语文', num: 70 },
        { id: 1, name: '英语', num: 60 },
        { id: 4, name: '物理', num: 50 },
        { id: 5, name: '化学', num: 40 },
      ],
    };
  },

};
</script>

<style lang="scss" scoped>
.school {
  box-sizing: border-box;
  width: 100%;
  height: 386px;
  padding: 20px;
  color: #f5f5f5;
  background: url("../../images/exhibition-school-top.png") no-repeat center /
    100%;
  &-title {
    line-height: 24px;
    font-size: 20px;
    text-indent: 32px;
    margin-bottom: 20px;
    background: url("../../images/exhibition-icon.png") no-repeat left top /
      24px;
  }
  &-progress {
    padding-top: 15px;
    height: 45px;
  }
  .el-progress {
    width: 100%;
    /deep/ {
      .el-progress__text {
        color: #fff;
        font-size: 14px;
      }
      .el-progress-bar__outer {
        height: 6px !important;
        border: 1px solid #122880;
        background-color: #122880 !important;
      }

      /* 渐变进度条 */
      .el-bg-inner-running .el-progress-bar__inner {
        background-color: unset;
        background-image: linear-gradient(to right, #3587d8, #6855ff);
      }
      .el-bg-inner-error .el-progress-bar__inner {
        background-image: linear-gradient(to right, #3587d8, #fb3a7e);
      }
      .el-bg-inner-done .el-progress-bar__inner {
        background-image: linear-gradient(to right, #3587d8, #53ff54);
      }
    }
  }
  .school-color {
      color: #FCE204;
      font-size: 20px;
    }
    .fz {
      font-size: 20px;
    }
    .mb {
      margin-bottom: 10px;
    }
    .lc {
      letter-spacing: 3px;
      margin-left: 3px;
    }
}
</style>
